import {
  UPDATE_DIGITAL_SALES_CURRENT_CACHE_KEY,
  GET_DIGITAL_SALES_APPLICATIONS_API_REQUEST,
  GET_DIGITAL_SALES_APPLICATIONS_API_SUCCESS,
  GET_DIGITAL_SALES_APPLICATIONS_API_ERROR,
  GET_NEXT_DIGITAL_SALES_APPLICATIONS_SUCCESS,
} from '../../../constants/digitalSalesActionNames';
import { checkCacheValid, generateCacheKey } from '../../../utils/functions/cache';
import { getApplicationsUrl } from '../../../apis/digitalSales/getDigitalSalesApplicationsApi';
import { getDigitalSalesApplicationsApi } from '../../../apis/digitalSales';

function updateCacheKey(cacheKey) {
  return {
    type: UPDATE_DIGITAL_SALES_CURRENT_CACHE_KEY,
    payload: cacheKey,
  };
}

function getDigitalSalesApplicationsRequest() {
  return {
    type: GET_DIGITAL_SALES_APPLICATIONS_API_REQUEST,
    payload: true,
  };
}

function getDigitalSalesApplicationsSuccess(applications, params, cacheKey) {
  return {
    type: GET_DIGITAL_SALES_APPLICATIONS_API_SUCCESS,
    payload: applications,
    params,
    cacheKey,
  };
}

function getDigitalSalesApplicationsError(err) {
  return {
    type: GET_DIGITAL_SALES_APPLICATIONS_API_ERROR,
    payload: err,
  };
}

export function getDigitalSalesApplicationsAction(params) {
  // const response = getPayloadResponse();
  return (dispatch, getState) => {
    const state = getState();
    params.alpha2 = state?.locations?.yourLocation?.alpha2;
    const cacheKey = generateCacheKey({
      path: getApplicationsUrl,
      cacheParams: params,
      state,
    });

    const { isCacheValid, cache } = checkCacheValid(getState, 'digitalSales', cacheKey);
    if (isCacheValid) {
      // dispatch(getClaimsSuccess(null, params, cacheKey, filteredLobCategories));
      dispatch(updateCacheKey(cacheKey));
      dispatch(getDigitalSalesApplicationsSuccess(cache, params, cacheKey));
      return Promise.resolve(cache);
    }

    dispatch(getDigitalSalesApplicationsRequest());
    return getDigitalSalesApplicationsApi
      .getDigitalSalesApplications(state, params)
      .then(data => {
        dispatch(getDigitalSalesApplicationsSuccess(data, params, cacheKey));
        return data;
      })
      .catch(error => {
        dispatch(getDigitalSalesApplicationsError(error));
        throw error;
      });
  };
}

function getNextDigitalSalesApplicationsSuccess(prod) {
  return {
    type: GET_NEXT_DIGITAL_SALES_APPLICATIONS_SUCCESS,
    payload: prod,
  };
}

export function getNextDigitalSalesApplicationsAction(data) {
  return getNextDigitalSalesApplicationsSuccess(data);
}

export default {
  getDigitalSalesApplicationsAction,
  getNextDigitalSalesApplicationsAction,
};
